
export const activeMarkerReducer = (state = {}, action) =>
{
    switch(action.type)
    {
        case 'ACTIVE_MARKER':
            return action.activeMarker;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/activeMarkerReducer.js